/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS103: Rewrite code to no longer use __guard__
 * DS104: Avoid inline assignments
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone from 'backbone';
import React from 'react';

import * as analytics from 'analytics/Analytics';
import FragmentRowTemplate from 'analyses/FragmentRowTemplate';
import DigestTabTemplate from 'analyses/DigestTabTemplate';
import DigestMenuTemplate from 'analyses/DigestMenuTemplate';
import * as selectioncontextmenu from 'components/SelectionContextMenu';
import EnzymeActivityTable from 'molbio/enzymes/EnzymeActivityTable';
import EnzymeProviderSelector from 'molbio/enzymes/EnzymeProviderSelector';
import * as EnzymeUtil from 'molbio/enzymes/EnzymeUtil';
import notifications from 'notifications';
import * as sequtil from 'molbio/SeqUtil';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';
import getTestProps from 'test/lib/cypress/getTestProps';

class OptionsView extends Backbone.View {
  static initClass() {
    this.prototype.tagName = 'div';
    this.prototype.className = 'navbar';
    this.prototype.template = DigestMenuTemplate;

    this.prototype.events = {
      'click .save': 'save',
      'keypress .tab-name': 'checkEnter',
      'keyup .tab-name': 'setFromText',
    };
  }

  initialize(options) {
    this.updateProvider = this.updateProvider.bind(this);
    this.sequence = this.model.get('sequence');
    this.listenTo(this.model.get('analysis'), 'change:provider', this.renderProviderSelector);
  }

  setFromText() {
    this.model.set('title', this.name.val().trim());
  }

  checkEnter(e) {
    if (e.which === 13) {
      this.save();
    }
  }

  save() {
    if (!this.model.get('sequence').allowFeatureEdits()) {
      return;
    }
    this.$('.save').button('loading');

    const analysis = this.model.get('analysis');
    analysis.set('name', this.name.val().trim());
    const saveWord = analysis.isNew() ? 'saved' : 'updated';
    this.sequence
      .get('analyses')
      .betterCreate(analysis)
      .always(() => this.$('.save').button('reset'))
      .done(() => {
        notifications.success(
          <>
            Digest <strong>{this.name.val()}</strong> successfully {saveWord}.
          </>
        );
        analytics.track('digest', 'saved_digest', {name: analysis.get('name')});
      })
      .fail(notifications.notifyError);
  }

  updateProvider(provider) {
    this.model.get('analysis').set({provider: provider.name});
  }

  renderProviderSelector() {
    const analysis = this.model.get('analysis');
    const allowFeatureEdits = this.sequence.allowFeatureEdits();

    const providers = EnzymeUtil.getProvidersForEnzymes(analysis.get('enzymes'));
    const selectedProvider = analysis.provider();

    renderToDOM(
      <EnzymeProviderSelector
        inline={true}
        providers={providers}
        value={selectedProvider}
        onChange={allowFeatureEdits ? this.updateProvider : undefined}
      />,
      this.$el.find('.enzymes-providers-mount')[0]
    );
  }

  render() {
    this.$el.html(this.template());
    this.renderProviderSelector();
    this.name = this.$el.find('.tab-name');
    if (this.sequence.allowFeatureEdits()) {
      this.name.bind('keypress', this.saveFromText);
    } else {
      this.name.prop('readonly', true);
      this.$('.save').addClass('disabled').text('Save (disabled in read-only mode)');
    }

    this.$('.save').attr({type: 'button', 'data-loading-text': 'Saving...'});

    this.name.val(this.model.get('analysis').get('name'));
    return this;
  }
}
OptionsView.initClass();

class FragmentRowView extends Backbone.View {
  static initClass() {
    this.prototype.tagName = 'tr';
    this.prototype.template = FragmentRowTemplate;

    this.prototype.events = {
      mousedown: 'selectFragment',
      contextmenu: 'contextMenu',
    };

    this.prototype.attributes = {
      ...this.prototype.attributes,
      ...getTestProps({component: 'FragmentRow', element: 'row'}),
    };
  }

  initialize(options) {
    this.sequence = options.sequence;
    this.listenTo(this.model, 'change:selected', this.handleSelectedChange);
  }

  contextMenu(e) {
    selectioncontextmenu.open(e, this.sequence, selectioncontextmenu.COPY_MENU);
  }

  selectFragment() {
    this.sequence.selectFragment(this.model);
  }

  handleSelectedChange(model, selected) {
    this.$el.toggleClass('active', selected);
  }

  render() {
    const leftCutterOverhang = this.model.leftOverhang();
    let leftCutterName = __guard__(this.model.get('_cutter5'), (x) => x.name);
    leftCutterName = leftCutterName != null ? leftCutterName : 'None';
    const rightCutterOverhang = this.model.rightOverhang();
    let rightCutterName = __guard__(this.model.get('_cutter3'), (x1) => x1.name);
    rightCutterName = rightCutterName != null ? rightCutterName : 'None';
    const [start, end] = Array.from(
      sequtil.modelRangeToDisplay(
        this.model.get('start'),
        this.model.get('end'),
        this.sequence.length(),
        this.sequence.startIndex()
      )
    );
    this.$el.html(
      this.template({
        start,
        end,
        length: this.model.get('length'),
        leftCutterName,
        leftCutterOverhang,
        rightCutterName,
        rightCutterOverhang,
      })
    );
    if (this.model.get('selected')) {
      this.$el.addClass('active');
    }
    return this;
  }
}
FragmentRowView.initClass();

class TabView extends Backbone.View {
  static initClass() {
    this.prototype.template = DigestTabTemplate;
    this.prototype.className = 'buffer-tab';
    this.prototype.events = {
      'click tr': 'selectFragment',
    };
  }

  initialize(options) {
    this.sequence = this.model.get('sequence');
    this._sequence = this.sequence.get('_sequence');
    this.listenTo(this._sequence, 'change:circular change:bases change:startIndex', this.render);
    this.listenTo(this.model, 'change:fragments', this.render);
    this.listenTo(this.model.get('analysis'), 'change:provider', this.renderEnzymes);
    this.rows = [];
  }

  renderEnzymes() {
    const provider = this.model.get('analysis').provider();
    const enzymeIds = this.model.get('analysis').get('enzymes');
    const enzymes = this.sequence.get('enzymes').getEnzymesJSON(enzymeIds);
    renderToDOM(<EnzymeActivityTable provider={provider} enzymes={enzymes} />, this.$el.find('.enzymes')[0]);
  }

  render() {
    const enzymeIds = this.model.get('analysis').get('enzymes');
    const enzymes = this.sequence.get('enzymes').getEnzymesJSON(enzymeIds);

    this.$el.html(this.template());
    this.renderEnzymes();

    if (enzymes.length !== 0) {
      const fragments = this.model.get('analysis').get('fragments');
      for (const fragment of Array.from(fragments.models)) {
        const row = new FragmentRowView({
          model: fragment,
          sequence: this.sequence,
        });
        this.rows.push(row);
        this.$el.find('.fragments-table tbody').append(row.render().el);
      }
    }
    return this;
  }

  remove() {
    for (const row of Array.from(this.rows)) {
      row.stopListening();
    }
    return super.remove();
  }
}
TabView.initClass();

export {OptionsView, TabView};

function __guard__(value, transform) {
  return value != null ? transform(value) : undefined;
}
